"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonGroupAlignment = exports.buttonGroupSpacing = exports.buttonVariant = exports.buttonSize = void 0;
exports.buttonSize = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    big: 'big', // deprecated
};
exports.buttonVariant = {
    primary: 'primary',
    secondary: 'secondary',
    success: 'success',
    destructive: 'destructive',
    tertiary: 'tertiary',
    tertiaryReversed: 'tertiaryReversed',
    text: 'text',
};
exports.buttonGroupSpacing = {
    small: 'small',
    large: 'large',
};
exports.buttonGroupAlignment = {
    left: 'left',
    center: 'center',
    right: 'right',
};
